export default () => {
    const containers = document.querySelectorAll(
        ".c-image-grid__image, .c-image-with-caption__image, .c-project-gallery__item, .c-project-hero__image, .c-post-hero__image",
    );

    if (!containers.length) return;

    // Build overlay
    const overlay = document.createElement("div");
    overlay.className = "c-lightbox";
    overlay.innerHTML =
        '<button class="c-lightbox__close" aria-label="Sluiten">&times;</button>' +
        '<button class="c-lightbox__prev" aria-label="Vorige">&#8249;</button>' +
        '<button class="c-lightbox__next" aria-label="Volgende">&#8250;</button>' +
        '<img class="c-lightbox__img" alt="" />';
    document.body.appendChild(overlay);

    const img = overlay.querySelector(".c-lightbox__img");
    const prevBtn = overlay.querySelector(".c-lightbox__prev");
    const nextBtn = overlay.querySelector(".c-lightbox__next");

    let images = [];
    let current = 0;

    // Collect all lightbox-eligible images
    containers.forEach((container) => {
        const sourceImg = container.querySelector("img");
        if (!sourceImg) return;

        container.style.cursor = "zoom-in";
        container.addEventListener("click", (e) => {
            e.preventDefault();
            // Rebuild list each time in case of lazy-loaded images
            images = [];
            containers.forEach((c) => {
                const i = c.querySelector("img");
                if (i) images.push(getSrc(i));
            });
            current = images.indexOf(getSrc(sourceImg));
            open(images[current]);
        });
    });

    function getSrc(imgEl) {
        // Prefer highest resolution: check <picture> sources or srcset
        var picture = imgEl.closest("picture");
        if (picture) {
            var sources = picture.querySelectorAll(
                "source[srcset], source[data-srcset]",
            );
            for (var s = sources.length - 1; s >= 0; s--) {
                var srcset =
                    sources[s].srcset || sources[s].dataset.srcset || "";
                var match = srcset.match(/(\S+)\s+2x/);
                if (match) return match[1];
            }
        }
        if (imgEl.srcset) {
            var parts = imgEl.srcset.split(",").map(function (s) {
                return s.trim();
            });
            var largest = parts[parts.length - 1].split(/\s+/)[0];
            if (largest) return largest;
        }
        return imgEl.currentSrc || imgEl.src || imgEl.dataset.src || "";
    }

    function open(src) {
        img.src = src;
        overlay.classList.add("c-lightbox--active");
        document.body.style.overflow = "hidden";
        prevBtn.style.display = images.length > 1 ? "" : "none";
        nextBtn.style.display = images.length > 1 ? "" : "none";
    }

    function close() {
        overlay.classList.remove("c-lightbox--active");
        document.body.style.overflow = "";
        img.src = "";
    }

    function navigate(dir) {
        current = (current + dir + images.length) % images.length;
        img.style.opacity = 0;
        setTimeout(() => {
            img.src = images[current];
            img.style.opacity = 1;
        }, 200);
    }

    overlay
        .querySelector(".c-lightbox__close")
        .addEventListener("click", close);
    prevBtn.addEventListener("click", () => navigate(-1));
    nextBtn.addEventListener("click", () => navigate(1));
    overlay.addEventListener("click", (e) => {
        if (e.target === overlay) close();
    });

    document.addEventListener("keydown", (e) => {
        if (!overlay.classList.contains("c-lightbox--active")) return;
        if (e.key === "Escape") close();
        if (e.key === "ArrowLeft") navigate(-1);
        if (e.key === "ArrowRight") navigate(1);
    });
};
